import React, {Component} from 'react';
import VisuallyHidden from '@reach/visually-hidden';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {push} from 'connected-react-router/immutable';
import {Trans} from '@lingui/macro';
import {Helmet} from 'react-helmet';

import {startTest} from '../../actions/tests';
import {getCurrentTest} from '../../reducers/tests';
import {HOME, TESTS} from '../../services/routes';
import {getIsMobile} from '../../reducers/ui';
import {getUserCampaign} from '../../reducers/userCampaign';
import {getCampaignLang} from '../../reducers/userCampaign';
import {i18n} from '../../services/i18n';

import {extractTranslatedLabel} from '../../services/utilities';
import TestDetails from '../../components/TestDetails';
import FlatButton from '../../components/FlatButton';
import ChevronRightIcon from '../../components/Icons/ChevronRightIcon';

import s from './StartTest.css';

const testInfo = ['duration'];
const infoLabels = {
  duration: <Trans id="start_test_info_labels_durata">Durata</Trans>,
};

class StartTest extends Component {
  goBackBtn = React.createRef();

  componentWillMount() {
    if (!this.props.currentTest || this.props.currentTest.size === 0) {
      this.props.push(HOME);
    }
  }

  componentDidMount() {
    //this.goBackBtn.current.focus();
  }

  startTest = () => {
    const {currentTest} = this.props;
    const testIs360 = currentTest.get('id') == 360;

    this.props.startTest({testIs360});
  };

  goBack = () => {
    if (this.props.isMobile) {
      this.props.push(TESTS);
      return;
    }

    this.props.push(HOME);
  };

  renderInfo = () => {
    const {currentTest} = this.props;

    return (
      <div className={s.Blocks}>
        {testInfo.map((info, i) => {
          const data = currentTest.getIn(['jsonData', info]);
          if (data === null || data === undefined) {
            return null;
          }

          return (
            <div className={s.BlockItem} key={i}>
              <p className={s.BlockTitle}>{infoLabels[info] || ''}</p>
              <p className={s.BlockData}>{currentTest.getIn(['jsonData', info])}</p>
            </div>
          );
        })}
      </div>
    );
  };
  render() {
    const {currentTest, lang, isMobile} = this.props;

    return (
      <div className={s.TestRoom} aria-describedby="start-test-description">
        <Helmet>
          <title>
            {i18n._('app.start_test_page_title', null, {
              defaults: 'Skillup - Istruzioni prova',
            })}
          </title>
        </Helmet>
        <div className={s.LeftColumn}>
          <div className={s.Information}>
            <FlatButton ref={this.goBackBtn} className={s.BackButton} onClick={this.goBack}>
              <VisuallyHidden>
                <Trans id="start_test.go_back">Torna indietro</Trans>
              </VisuallyHidden>
              <ChevronRightIcon className={s.BackIcon} />
            </FlatButton>
          </div>
          <h1 className={s.Title} aria-live="assertive" aria-atomic="true">{extractTranslatedLabel(currentTest, lang, 'name')}</h1>
          <div className={s.Divider} />

          <div className={s.Info}>
            <div className={s.Description}>
              <p id="start-test-description">
                {extractTranslatedLabel(currentTest, lang, 'description')}
              </p>
            </div>

            {this.renderInfo()}

            <div className={s.Instructions}>
              <p>{extractTranslatedLabel(currentTest, lang, 'instructions')}</p>
            </div>
          </div>
        </div>
        <div className={s.RightColumn}>
          {currentTest && currentTest.size > 0 ? (
            <TestDetails
              isMobile={isMobile}
              currentTest={currentTest}
              lang={lang}
              startTest={this.startTest}
              goBack={this.goBack}
            />
          ) : null}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const currentTest = getCurrentTest(state);
  const userCampaign = getUserCampaign(state);
  const lang = getCampaignLang(state);
  const isMobile = getIsMobile(state);

  return {
    currentTest,
    userCampaign,
    lang,
    isMobile,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({startTest, push}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(StartTest);
